var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hamburger-wrapper", on: { click: _vm.toggleMenu } },
    [
      _c(
        "div",
        { staticClass: "hamburger-button", class: { active: _vm.active } },
        [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
      ),
      _vm._v(" "),
      _c("p", { class: _vm.textClasses }, [_vm._v("Menu")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }